import {createSvgIcon} from '../create-svg-icon';

export const StopIcon = createSvgIcon(
  <path d="M16 8v8H8V8h8m2-2H6v12h12V6z" />
, 'StopOutlined');
